import { useDispatch, useSelector } from "react-redux"
import { clearSelectedSetup, selectSetupName } from "../../../features/system/systemSlice"
import { useMasterData } from "../../../hooks/api/useMasterData"
import { setSetup } from "../../../features/setup/setupSlice"
import SetupTHead from "../theads/SetupTHead"
import { setUpSize } from "../../../data/admin-data"
import SetupSizesTBody from "../tbody/SetupSizesTBody"
import SetupHeader from "../headers/SetupHeader"

export default function SetupSize() {

    const dispatch = useDispatch()
    const { getSizes, isLoadingGetSizes, isErrorGetSizes, errorMessageGetSizes, } = useMasterData()
    const selectedSetupName = useSelector(selectSetupName)

    return (
        <>
            <SetupHeader
                onClick={() => dispatch(clearSelectedSetup())}
                handleClickNew={() => dispatch(setSetup({ type: 'show', value: 'setUpSize'}))}
                selectedSetupName={selectedSetupName}
            />
            <div className='h-full overflow-hidden bg-white rounded border'>
                <div className='overflow-y-auto h-full'>
                    <table className='min-w-max w-full'>
                        <SetupTHead data={setUpSize}/> 
                        <SetupSizesTBody
                            data={getSizes}
                            isLoading={isLoadingGetSizes}
                            isError={isErrorGetSizes}
                            errorMessage={errorMessageGetSizes}
                            isEmpty={getSizes.length === 0}
                        />
                    </table>
                </div>
            </div>
        </>
    )
}
